import React from 'react'
import './Partner.css'
import cus1 from '../../assets/cus1.png'
import cus2 from '../../assets/cus2.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import SwiperCore, { Autoplay } from 'swiper';
SwiperCore.use([Autoplay])
const Partner = () => {


    return (
      <div className="partner__container">
          <h1 className={"heading_section"}>عملائنا</h1>
          <Swiper
              slidesPerView={3}
              onSlideChange={() => console.log('slide change')}
              onSwiper={(swiper) => console.log(swiper)}
              loop={true}
              autoplay={{
                  delay: 500,
                  disableOnInteraction: false,

              }}
          >
                     <SwiperSlide className="partner__img">
                         <img src={cus1} alt=""/>
                     </SwiperSlide>

                     <SwiperSlide className="partner__img">
                         <img src={cus2} alt=""/>
                     </SwiperSlide>

                     <SwiperSlide className="partner__img">
                         <img src={cus1} alt=""/>
                     </SwiperSlide>

              <SwiperSlide className="partner__img">
                  <img src={cus2} alt=""/>
              </SwiperSlide>

              <SwiperSlide className="partner__img">
                  <img src={cus2} alt=""/>
              </SwiperSlide>
              <SwiperSlide className="partner__img">
                  <img src={cus2} alt=""/>
              </SwiperSlide>
             </Swiper>
      </div>

  );
};
export default Partner;